import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { GET } from "../../services/axios.service";
import { SampleProps } from "../../types/sample";

export interface OpenSampleState {
  samples: SampleProps[];
  totalSamples: number;
  search: string | null;
  loading: boolean;
  error: string | null;
}

const initialState: OpenSampleState = {
  samples: [],
  totalSamples: 0,
  search: null,
  loading: false,
  error: null,
};

export const fetchOpenSamplesData = createAsyncThunk(
  "fetchOpenSamplesData",
  async (req: { page: number; search?: string }) => {
    let response: any;
    await GET(`/v1/worker/samples`, { ...req, status: 0 })
      .then((res: any) => {
        response = res;
      })
      .catch((err) => {
        response = err;
      });
    return response;
  }
);

export const openSampleSlice = createSlice({
  name: "openSample",
  initialState,
  reducers: {
    updateSearch: (state, action: PayloadAction<string | null>) => {
      state.search = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchOpenSamplesData.pending, (state, action: any) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchOpenSamplesData.fulfilled, (state, action: any) => {
      state.loading = false;
      if (action.payload.data.status === "success") {
        if (
          action.payload.data.data.records.length > 0 &&
          action.payload.data.data.page > 1
        )
          state.samples = [
            ...state.samples,
            ...action.payload.data.data.records,
          ];
        else state.samples = action.payload.data.data.records;
        state.totalSamples = action.payload.data.data.total_records;
        state.error = null;
      } else {
        state.samples = [];
        state.error =
          action?.payload?.data?.message ||
          "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
      }
    });
  },
});

export const { updateSearch } = openSampleSlice.actions;

export const getSamples = (state: RootState) => state.openSample.samples;

export const getTotalSamples = (state: RootState) =>
  state.openSample.totalSamples;

export const getSearch = (state: RootState) => state.openSample.search;

export default openSampleSlice.reducer;
